import React, { useContext } from 'react';
import styled from 'styled-components';
import { FaSearch } from "react-icons/fa";
import { useLocation } from 'react-router-dom';
import { SearchContext } from './SearchContext'; // ✅ Import context

const NavBarSearchBar = () => {
  const location = useLocation();
  const { searchTerm, setSearchTerm } = useContext(SearchContext); // ✅ Use context

  const isHome =
    location.pathname === '/' ||
    location.pathname === '/categories' ||
    location.pathname === '/top-coupons' ||
    location.pathname === '/best-offers' ||
    location.pathname === '/dashboard';

  const handleSubmit = (e) => {
    e.preventDefault();
   // console.log('Search:', searchTerm); // optional logging
  };

  return (
    <Wrapper className={isHome ? 'home-style' : 'about-style'}>
      <form onSubmit={handleSubmit}>
        <input
          type="search"
          placeholder="Search for store, coupons & offers"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)} // ✅ Update searchTerm
          className='ps-2'
        />
        <button type="submit">
          <FaSearch className="icon" />
        </button>
      </form>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: #f9f9f9;

  form {
    display: flex;
    align-items: center;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    width:85%;
  }

  input {
    height: 36px;
    // padding: 0 12px;
    font-size: 15px;
    border: 1px solid #ccc;
    border-right: none;
    border-radius: 4px 0 0 4px;
    background-color: rgba(255, 255, 255, 0.9);
    outline: none;
    width:100%;
  }

  button {
    height: 36px;
    padding: 0 12px;
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-left: none;
    border-radius: 0 4px 4px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  button:hover {
    background-color: #f0f0f0;
  }

  .icon {
    font-size: 1rem;
    color: #ef4766;
  }

  &.about-style {
    background-color: #eeeeee;
  }

  &.home-style {
    background-color: transparent;
  }

  @media (min-width: 992px) {
    display: none;
  }
`;

export default NavBarSearchBar;
